import { Fragment } from "react";

import { css } from "@compiled/react";

import { withFeatureExposed } from "@/utils/feature-exposed";

const carouselStyle = css({
    overflow: "hidden",
    height: "36px",
    position: "relative",
    paddingBlockStart: "24px",
    width: "100%",
    boxSizing: "content-box"
});

const trackStyle = css({
    ["@keyframes scroll"]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        from: {
            transform: "translateX(0)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        to: {
            transform: "translateX(-50%)"
        }
    },
    animation: "scroll 11s linear infinite",
    display: "flex",
    gap: "32px",
    position: "absolute"
});

const logoStyle = css({
    pointerEvents: "none",
    filter: "grayscale(100%) brightness(66%)",
    height: "36px",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
});

const SocialEndorsementComponent = () => {
    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg",
            alt: "Canva",
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg",
            alt: "Nasa",
            width: 60
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg",
            alt: "Illumina",
            width: 103
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg",
            alt: "Docker",
            width: 108
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg",
            alt: "The New York Times",
            width: 165
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg",
            alt: "Audi",
            width: 68
        }
    ];

    return (
        <div css={carouselStyle} data-testid="cfind-2675-social-proof">
            <div css={trackStyle}>
                {[...logos, ...logos].map((logo, index) => (
                    <Fragment key={index}>
                        {/* eslint-disable-next-line no-restricted-syntax */}
                        <img
                            src={logo.src}
                            css={logoStyle}
                            alt={logo.alt}
                            loading="lazy"
                            width={logo.width}
                        />
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export const SocialEndorsement = withFeatureExposed(
    "cfind-2675-social-proof-paid",
    "true",
    SocialEndorsementComponent
);
